export const LoginNav = [
  {
    icon: "pe-7s-map-2",
    label: "ソーシャルマップ",
    content: [
      {
        label: "マップ",
        to: "#/dashboards/journy",
      },
      {
        label: "リスト",
        to: "#/dashboards/list",
      },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-gleam",
    label: "トレンド",
    to: "#/dashboards/market",
  },

  {
    icon: "pe-7s-users",
    label: "マイページ",
    to: "#/dashboards/plofile-individual",
  },

  {
    icon: "pe-7s-lock",
    label: "オーガニゼーション",
    to: "#/dashboards/org_feature",
  },

  {
    icon: "pe-7s-light",
    label: "サービスについて",
    content: [
      {
        label: "オーガニゼーション機能",
        to: "#/dashboards/org_feature",
      },
      {
        label: "FAQ",
        to: "#/dashboards/faq",
      },
      {
        label: "手法・解説",
        to: "#/dashboards/method",
      },
      {
        label: "開発・連携状況",
        to: "#/dashboards/status",
      },
      // {
      //   label: "運営会社・規約等",
      //   to: "#/dashboards/tempo",
      // },
      {
        label: "運営会社・規約等",
        to: "#/dashboards/policy",
      },
      // {
      //   label: "EMAについて",
      //   to: "https://ema-di.jp/ema/",
      //   externalLink: true,
      // },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-comment",
    label: "お問い合わせ",
    to: "#/dashboards/contact",
  },

  // {
  //   icon: "pe-7s-like",
  //   label: "決済",
  //   to: "#/dashboards/pricing",
  // },
];

export const LoginNavWithoutSupporterAndCso = [
  {
    icon: "pe-7s-map-2",
    label: "ソーシャルマップ",
    content: [
      {
        label: "マップ",
        to: "#/dashboards/journy",
      },
      {
        label: "リスト",
        to: "#/dashboards/list",
      },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-gleam",
    label: "トレンド",
    to: "#/dashboards/market",
  },

  {
    icon: "pe-7s-users",
    label: "マイページ",
    to: "#/dashboards/plofile-individual",
  },

  {
    icon: "pe-7s-lock",
    label: "オーガニゼーション",
    to: "#/dashboards/org_feature",
  },

  {
    icon: "pe-7s-light",
    label: "サービスについて",
    content: [
      {
        label: "オーガニゼーション機能",
        to: "#/dashboards/org_feature",
      },
      {
        label: "FAQ",
        to: "#/dashboards/faq",
      },
      {
        label: "手法・解説",
        to: "#/dashboards/method",
      },
      {
        label: "開発・連携状況",
        to: "#/dashboards/status",
      },
      // {
      //   label: "運営会社・規約等",
      //   to: "#/dashboards/tempo",
      // },
      {
        label: "運営会社・規約等",
        to: "#/dashboards/policy",
      },
      // {
      //   label: "EMAについて",
      //   to: "https://ema-di.jp/ema/",
      //   externalLink: true,
      // },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-comment",
    label: "お問い合わせ",
    to: "#/dashboards/contact",
  },

  // {
  //   icon: "pe-7s-like",
  //   label: "決済",
  //   to: "#/dashboards/pricing",
  // },
];

export const LoginNavWithOrg = (isSupporter) => [
  {
    icon: "pe-7s-map-2",
    label: "ソーシャルマップ",
    content: [
      {
        label: "マップ",
        to: "#/dashboards/journy",
      },
      {
        label: "リスト",
        to: "#/dashboards/list",
      },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-gleam",
    label: "トレンド",
    to: "#/dashboards/market",
  },

  {
    icon: "pe-7s-users",
    label: "マイページ",
    to: "#/dashboards/plofile-individual",
  },

  {
    icon: "pe-7s-culture",
    label: "オーガニゼーション",
    content: isSupporter
      ? [
          {
            label: "組織情報",
            to: "#/dashboards/plofile-organization/",
          },
          {
            label: "パートナーシップ",
            to: "#/dashboards/organization-partnership",
          },
        ]
      : [
          {
            label: "組織情報",
            to: "#/dashboards/plofile-organization/",
          },
          {
            label: "組織分析",
            to: "#/dashboards/analytics",
          },
          {
            label: "比較分析",
            to: "#/dashboards/comparison",
          },
          {
            label: "組織診断",
            to: "#/dashboards/evaluation",
          },
          {
            label: "パートナーシップ",
            to: "#/dashboards/organization-partnership",
          },
        ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-light",
    label: "サービスについて",
    content: [
      {
        label: "オーガニゼーション機能",
        to: "#/dashboards/org_feature",
      },
      {
        label: "FAQ",
        to: "#/dashboards/faq",
      },
      {
        label: "手法・解説",
        to: "#/dashboards/method",
      },
      {
        label: "開発・連携状況",
        to: "#/dashboards/status",
      },
      // {
      //   label: "運営会社・規約等",
      //   to: "#/dashboards/tempo",
      // },
      {
        label: "運営会社・規約等",
        to: "#/dashboards/policy",
      },
      // {
      //   label: "EMAについて",
      //   to: "https://ema-di.jp/ema/",
      //   externalLink: true,
      // },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-comment",
    label: "お問い合わせ",
    to: "#/dashboards/contact",
  },

  // {
  //   icon: "pe-7s-like",
  //   label: "決済",
  //   to: "#/dashboards/pricing",
  // },
];

export const NotLoginNav = [
  {
    icon: "pe-7s-map-2",
    label: "ソーシャルマップ",
    content: [
      {
        label: "マップ",
        to: "#/dashboards/journy",
      },
      {
        label: "リスト",
        to: "#/dashboards/list",
      },
    ],

    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-gleam",
    label: "トレンド",
    to: "#/dashboards/market",
  },

  {
    icon: "pe-7s-lock",
    label: "オーガニゼーション",
    to: "#/dashboards/org_feature",
    // content: [
    //   {
    //     label: "パートナーシップ",
    //     to: "#/dashboards/organization-partnership",
    //   },
    // ],
  },

  {
    icon: "pe-7s-light",
    label: "サービスについて",
    content: [
      {
        label: "オーガニゼーション機能",
        to: "#/dashboards/org_feature",
      },
      {
        label: "FAQ",
        to: "#/dashboards/faq",
      },
      {
        label: "手法・解説",
        to: "#/dashboards/method",
      },
      {
        label: "開発・連携状況",
        to: "#/dashboards/status",
      },
      // {
      //   label: "運営会社・規約等",
      //   to: "#/dashboards/tempo",
      // },
      {
        label: "運営会社・規約等",
        to: "#/dashboards/policy",
      },
      // {
      //   label: "EMAについて",
      //   to: "https://ema-di.jp/ema/",
      //   externalLink: true,
      // },
    ],
    preventDefaultOnClick: true,
  },
  {
    icon: "pe-7s-comment",
    label: "お問い合わせ",
    to: "#/dashboards/contact",
  },
];

// mobile
export const NotLoginNavMobile = [
  {
    icon: "pe-7s-map-2",
    label: "ソーシャルマップ",
    preventDefaultOnClick: true,
    content: [
      {
        label: "マップ",
        to: "#/dashboards/journy",
      },
      {
        label: "リスト",
        to: "#/dashboards/list",
      },
    ],
  },

  {
    icon: "pe-7s-gleam",
    label: "トレンド",
    to: "#/dashboards/market",
  },

  {
    icon: "pe-7s-lock",
    label: "オーガニゼーション",
    to: "#/dashboards/org_feature",
    // content: [
    //   {
    //     label: "パートナーシップ",
    //     to: "#/dashboards/organization-partnership",
    //   },
    // ],
  },

  {
    icon: "pe-7s-light",
    label: "サービスについて",
    content: [
      {
        label: "オーガニゼーション機能",
        to: "#/dashboards/org_feature",
      },
      {
        label: "FAQ",
        to: "#/dashboards/faq",
      },
      {
        label: "手法・解説",
        to: "#/dashboards/method",
      },
      {
        label: "開発・連携状況",
        to: "#/dashboards/status",
      },
      // {
      //   label: "運営会社・規約等",
      //   to: "#/dashboards/tempo",
      // },
      {
        label: "運営会社・規約等",
        to: "#/dashboards/policy",
      },
      // {
      //   label: "EMAについて",
      //   to: "https://ema-di.jp/ema/",
      //   externalLink: true,
      // },
    ],

    preventDefaultOnClick: true,
  },
  {
    icon: "lnr-enter",
    label: "ログイン",
    to: "#/pages/login",
  },
  {
    icon: "lnr-user",
    label: "新規登録",
    to: "#/dashboards/journy?modal=true",
  },
  {
    icon: "pe-7s-comment",
    label: "お問い合わせ",
    to: "#/dashboards/contact",
  },
];

export const LoginNavWithOrgIsSupporter = [
  {
    icon: "pe-7s-map-2",
    label: "ソーシャルマップ",
    content: [
      {
        label: "マップ",
        to: "#/dashboards/journy",
      },
      {
        label: "リスト",
        to: "#/dashboards/list",
      },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-gleam",
    label: "トレンド",
    to: "#/dashboards/market",
  },

  {
    icon: "pe-7s-users",
    label: "マイページ",
    to: "#/dashboards/plofile-individual",
  },

  {
    icon: "pe-7s-culture",
    label: "オーガニゼーション",
    content: [
      {
        label: "組織情報",
        to: "#/dashboards/plofile-organization/",
      },
      {
        label: "パートナーシップ",
        to: "#/dashboards/organization-partnership",
      },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-light",
    label: "サービスについて",
    content: [
      {
        label: "オーガニゼーション機能",
        to: "#/dashboards/org_feature",
      },
      {
        label: "FAQ",
        to: "#/dashboards/faq",
      },
      {
        label: "手法・解説",
        to: "#/dashboards/method",
      },
      {
        label: "開発・連携状況",
        to: "#/dashboards/status",
      },
      // {
      //   label: "運営会社・規約等",
      //   to: "#/dashboards/tempo",
      // },
      {
        label: "運営会社・規約等",
        to: "#/dashboards/policy",
      },
      // {
      //   label: "EMAについて",
      //   to: "https://ema-di.jp/ema/",
      //   externalLink: true,
      // },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-comment",
    label: "お問い合わせ",
    to: "#/dashboards/contact",
  },

  // {
  //   icon: "pe-7s-like",
  //   label: "決済",
  //   to: "#/dashboards/pricing",
  // },
];

export const LoginNavWithOrgIsNotSupporter = [
  {
    icon: "pe-7s-map-2",
    label: "ソーシャルマップ",
    content: [
      {
        label: "マップ",
        to: "#/dashboards/journy",
      },
      {
        label: "リスト",
        to: "#/dashboards/list",
      },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-gleam",
    label: "トレンド",
    to: "#/dashboards/market",
  },

  {
    icon: "pe-7s-users",
    label: "マイページ",
    to: "#/dashboards/plofile-individual",
  },

  {
    icon: "pe-7s-culture",
    label: "オーガニゼーション",
    content: [
      {
        label: "組織情報",
        to: "#/dashboards/plofile-organization/",
      },
      {
        label: "組織分析",
        to: "#/dashboards/analytics",
      },
      {
        label: "比較分析",
        to: "#/dashboards/comparison",
      },
      {
        label: "組織診断",
        to: "#/dashboards/evaluation",
      },
      {
        label: "パートナーシップ",
        to: "#/dashboards/organization-partnership",
      },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-light",
    label: "サービスについて",
    content: [
      {
        label: "オーガニゼーション機能",
        to: "#/dashboards/org_feature",
      },
      {
        label: "FAQ",
        to: "#/dashboards/faq",
      },
      {
        label: "手法・解説",
        to: "#/dashboards/method",
      },
      {
        label: "開発・連携状況",
        to: "#/dashboards/status",
      },
      // {
      //   label: "運営会社・規約等",
      //   to: "#/dashboards/tempo",
      // },
      {
        label: "運営会社・規約等",
        to: "#/dashboards/policy",
      },
      // {
      //   label: "EMAについて",
      //   to: "https://ema-di.jp/ema/",
      //   externalLink: true,
      // },
    ],
    preventDefaultOnClick: true,
  },

  {
    icon: "pe-7s-comment",
    label: "お問い合わせ",
    to: "#/dashboards/contact",
  },

  // {
  //   icon: "pe-7s-like",
  //   label: "決済",
  //   to: "#/dashboards/pricing",
  // },
];
